import { stitchLink } from "../../../utils/general";
import {  __GetContentTypeConfigNew } from "../../../utils/getters/gettersV2";
import { parseSpecialConfigSyntax } from "@okf/ootils";
import { getRoutePathToMyContent, getRoutePathToReviewDashboard } from "../../../utils/routePathGenerators";


export const getRedirectUrl = {

    onClose : ({isModerate, content, SELF_MANAGED_BASE_CONFIGS}) => {
        const {meta: {kp_content_type : contentType}, kp_published_status: publishedStatus} = content;
        const {publishing: SM_onCloseRedirRoute} = SELF_MANAGED_BASE_CONFIGS?.contentPageRelated?.onCloseRedirectRoute || {}
        const segment = __GetContentTypeConfigNew(contentType).general?.segment
        switch(segment){
            case 'collections':
            return `/platformBuilder/tagsManager/${contentType}`
            
            case 'staticPages':
            return '/platformBuilder/staticPages'      

            case 'publishing':
            default:
            return isModerate
                ? parseSpecialConfigSyntax({
                    config: SM_onCloseRedirRoute?.moderateMode || getRoutePathToReviewDashboard({ SELF_MANAGED_BASE_CONFIGS, activeTab: "underMyReview" }),
                    content: { contentType, contentId: content._id}
                })
                : publishedStatus === 'editPublished'
                    ? parseSpecialConfigSyntax({
                        config: SM_onCloseRedirRoute?.editMode || getRoutePathToMyContent({ SELF_MANAGED_BASE_CONFIGS, activeTab: "published" }),
                        content: { contentType, contentId: content._id}
                    })
                    : parseSpecialConfigSyntax({
                        config: SM_onCloseRedirRoute?.editMode || getRoutePathToMyContent({ SELF_MANAGED_BASE_CONFIGS, activeTab: "draft" }),
                        content: { contentType, contentId: content._id}
                    })
                    
        }

    },

    onPublish : ({userAction, content, SELF_MANAGED_BASE_CONFIGS}) => {
        const { meta: {kp_content_type: contentType}} = content
        
        const {general, listing } = __GetContentTypeConfigNew(contentType);
        const {segment, postPblRedirPath} = general || {}
        const {publishing: SM_pubRedirRoute} = SELF_MANAGED_BASE_CONFIGS?.contentPageRelated?.onPublishRedirectRoute || {}
        const defaultsBySegment = {
            publishing : listing?.enable 
                ? parseSpecialConfigSyntax({
                    config: SM_pubRedirRoute || `/published-page/${contentType}?id=${content._id}`,
                    content: {contentType, contentId: content._id}
                }) 
                : '/',
            collections : `/platformBuilder/tagsManager/${contentType}`,
            staticPages : `/platformBuilder/staticPages`  
        }

        if(userAction === 'SUBMIT') return getRoutePathToMyContent({ SELF_MANAGED_BASE_CONFIGS, activeTab: "inReview" })
        
        //else if no config, then use defaults
        if(!postPblRedirPath) return defaultsBySegment[segment];
            
        //else postPblRedirPath is defined
        switch(true){
            case typeof postPblRedirPath === 'string':
            return postPblRedirPath;
            
            case (
                postPblRedirPath.STITCH_LINK /** back-compat */ || 
                postPblRedirPath.type === 'dynamic'
            ) :
            return stitchLink(content, postPblRedirPath) 
            
            case postPblRedirPath.type === 'static':
                return postPblRedirPath.staticUrl;

            case postPblRedirPath.type === 'default':
                return defaultsBySegment[segment];

            default:
                return;    
        }
    }

}


// returns props for ConfirmAction comp
export const getConfirmActionProps = ({
  config,
  contentType,
}) => {

  if (
    !config?.enable ||
    !config?.contentTypes ||
    !config?.contentTypes[contentType]
  ) {
    return { enabled: false };
  }

  const configObj = config.contentTypes[contentType];

  return { ...configObj, enabled: true };
};
